<template>
  <div class="topic-box">
    <!-- header -->
    <div class="header-box">
      <img
        src="http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/TOPBG.png"
        alt=""
      />
      <div class="header-text">
        <p>引 语</p>
        <p>{{ text }}</p>
      </div>
    </div>

    <!-- content -->
    <div class="content-box hasPadding">
      <ListItem @detail-id="showCover" :infoList="infoList"></ListItem>
      <div class="share-bt" @click="share">
        马上分享
      </div>
    </div>

    <div class="comment-box hasPadding">
      <comment
        v-if="wxUserInfo.userDataStatus"
        @event-collection="eventCollection"
        :is-collection="isCollection"
        :qa-id="$route.params.id"
        :type="0"
        name="专题集合-001"
        editor="专题集合-001"
        compnent-color="#fff"
      ></comment>
    </div>

    <img
      @click="share"
      class="share-box"
      src="http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/%E5%88%86%E4%BA%AB.png"
      alt=""
    />

    <div v-show="showDetail" class="dialog-demo" @touchmove.prevent.stop>
      <div class="dialog-div">
        <p class="iconfont icon-close1" @click="close"></p>
        <div class="dialog-d2">
          <iframe
            :src="iframeUrl"
            ref="contentIframe"
            id="show-iframe"
            frameborder="0"
            name="showHere"
            scrolling="auto"
            height="100%"
            width="100%"
          ></iframe>
        </div>
      </div>
    </div>

    <x-dialog
      v-model="showShare"
      hide-on-blur
      @click.native="showShare = false"
      :dialog-style="{
        'max-width': '100%',
        width: '100%',
        height: '90%',
        'background-color': 'transparent'
      }"
    >
      <p style="color:#fff;text-align:center;">
        <img src="http://cdn.yxvzb.com/img/share-it.png" alt="" />
        <br />
        <br />
        <span style="font-size:.4rem">点击右上角分享</span>
      </p>
    </x-dialog>
  </div>
</template>
<script>
import ListItem from './components/ListItem.vue';
import comment from '@/components/Comment/index.vue';
import { contentview } from '@/Mixin/contentview.js';
import { mapState, mapActions } from 'vuex';
// TODO: vux
import { XDialog } from 'vux';
export default {
  name: '',
  mixins: [contentview],
  data() {
    return {
      detailObj: {
        courseName: '专题-资讯合集7月'
      },
      categoriesArr: [
        { categoryName: '', id: '' },
        { categoryName: '', id: '' }
      ],
      showShare: false,
      showDetail: false,
      iframeUrl:
        'http://cdn.yxvzb.com/staticPage/newInfo/a1ba19a8-958a-40f8-a6ef-4db97f903d04.html',
      id: 1,
      text:
        '2018年，大家都比较关注哪些医学热点呢？哪些专业文章/科普知识更受欢迎呢？马上随小编一起来关注一下吧~',
      isCollection: false,
      infoList: [
        {
          id: 'ded8fe73-b05d-4e1a-baf5-41e13790a345',
          htmlId: 'ded8fe73-b05d-4e1a-baf5-41e13790a345',
          sort: 'NO.1',
          hot: '22w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P01.png',
          name: '不只是头孢，服这7类药物饮酒也致死',
          des:
            '都说“酒后不吃药，吃药不喝酒”，但经常有人不当回事。有几大类药物对酒精的反应特别致命的，一旦引发双硫仑反应，就会危及生命！'
        },
        {
          id: 'd99bb1d7-b969-44e1-a945-a85906ba1edf',
          sort: 'NO.2',
          hot: '19.8w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P02.png',
          name: '它的毒性是砒霜的68倍，开水煮不死！中…..',
          des:
            '提到黄曲霉毒素，大家可能不太了解是什么东西。<br />而它的毒性是砒霜的68倍！<br />关于黄曲霉素，你知道的越多越好。'
        },
        {
          id: '8654faf3-53e8-4a19-9ef8-b2847cea8704',
          sort: 'NO.3',
          hot: '19.3w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P03.png',
          name: '喝酒到底是养生还是要命？世界顶尖医学….',
          des:
            '很多人觉得喝酒是不是对心血管有好处？<br />世界顶尖医学杂志《柳叶刀》，<br />发了一篇涉及多国结果的“饮酒”研究，<br />让你对喝酒有正确的认识！'
        },
        {
          id: '892e872e-1f47-4dfc-96cb-7ba60c41a8f5',
          sort: 'NO.4',
          hot: '17.6w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P04.png',
          name: '狂犬病死亡率近100%！这些救命知识你….',
          des:
            '我们说说狂犬疫苗接种那些事儿，<br />被动物咬伤/抓伤后，<br />狂犬疫苗接种的21个相关问题。'
        },
        {
          id: '264dc708-07c7-47af-9106-fd55f7e79a38',
          sort: 'NO.5',
          hot: '15.8w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P05.png',
          name: '最新公布的科学长寿法，排第一的竟是…',
          des:
            '世界各国研究机构公布了许多新的研究成果，<br />我们据此列出20个长寿方法，<br />简单易学，大家一定要看一看！'
        },
        {
          id: '1b2410ca-a817-46e4-b603-5b4bb73a0841',
          sort: 'NO.6',
          hot: '15.2w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P06.png',
          name: '阿司匹林抗癌作用终于出指南了',
          des:
            '关于阿司匹林与癌症的关系，<br />众说纷纭，<br />现在这个问题终于有定论了。'
        },
        {
          id: '4eb0fbe4-1121-4c3c-96de-5ef96a639da4',
          sort: 'NO.7',
          hot: '13.8w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P07.png',
          name: '感冒的真相：感冒后必做的9件事！',
          des:
            '美国威斯康星大学医学与公共卫生学院，<br />发布了一份《感冒白皮书》，<br />为我们揭露了有关感冒的三个“一”真相'
        },
        {
          id: '3124f11e-77f7-4770-b5d2-d37cb22a835f',
          sort: 'NO.8',
          hot: '11.5w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P08.png',
          name: '14岁男孩突发脑梗！这个最年轻的病例为….',
          des:
            '江西一医院收治了一位脑梗小患者，<br />只有14岁，还在读初中，<br />这个小朋友非常喜欢喝饮料，<br />这么年轻就得了脑梗跟这有一定的关系！'
        },
        {
          id: '9ad77649-2951-4c3b-8df9-634844eddcd7',
          sort: 'NO.9',
          hot: '11.2w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P09.png',
          name: '19个科室医生的忠告，为你爱的人看一遍',
          des:
            '19个科室医生忠告：<br />“最不希望大家做的一件事”<br />一定要记牢，否则很容易招病上身哦！'
        },
        {
          id: 'ecbede35-e0d0-4a66-946c-614ff7e539e7',
          sort: 'NO.10',
          hot: '10.6w+',
          bg: 'http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/P10.png',
          name: 'BBC解剖了一个200斤女子，看完你会用....',
          des:
            '最近BBC有一部纪录片震惊全球，<br />他们用最直观的方式告诉你肥胖有对可怕，<br />纪录片的名字叫——解剖肥胖！'
        }
      ]
    };
  },
  methods: {
    eventCollection(val) {
      this.isCollection = val;
    },
    showCover(v) {
      this.showDetail = true;
      // console.log(v)
      this.iframeUrl = `http://cdn.yxvzb.com/staticPage/newInfo/${v}.html`;
    },
    share() {
      this.showShare = true;
    },
    close() {
      this.iframeUrl = '';
      this.showDetail = false;
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {
    ListItem,
    comment,
    XDialog
  },
  created() {
    this.pageStayTime('专题');
    let shareCallBackFunc = () => {
      // 分享埋点
      // this.$sa.re_interaction({
      //   type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
      //   contentype:this.detailObj.type, // 互动主体 直播，录播，资讯，病例，站内信，论坛
      //   contentid: this.$route.params.id, // 内容id
      //   first_cate: '', //一级分类
      //   second_cate: '', // 2级分类
      //   first_cate_id:  '',    // 1级分类id
      //   second_cate_id:'', //2级分类id
      //   author:this.detailObj.editor || '', //讲师/作者
      //   // location:'', //位置 站内，专区内，超级面对面内
      // })
      // 分享埋点
      this.$sa.re_interaction({
        type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: '专题', // 互动主体 直播，录播，资讯，病例，站内信，论坛
        contentid: this.$route.params.id, // 内容id
        first_cate: '', //一级分类
        second_cate: '', // 2级分类
        first_cate_id: '', // 1级分类id
        second_cate_id: '', //2级分类id
        author: this.detailObj.editor || '', //讲师/作者
        contentname: '专题-资讯合集7月'
        // location:'', //位置 站内，专区内，超级面对面内
      });
    };
    //
    let shareUrl = location.href;
    if (!/shareFlag=true/.test(shareUrl)) {
      shareUrl = shareUrl + '?shareFlag=true';
    }

    this.$wxShareInfo(
      '2018年最受欢迎的医学热点 TOP 10',
      '2018年，大家都比较关注哪些医学热点呢？',
      'http://cdn.yxvzb.com/newWechat/image/logo98.png',
      location.href,
      shareUrl,
      shareCallBackFunc
    );
  }
};
</script>

<style lang="less" scoped>
.topic-box {
  background: #2d26cf;
  position: relative;
  padding-bottom: 1rem;
  .header-box {
    position: relative;
    .header-text {
      font-size: 0.3467rem /* 26/75 */;
      color: #ffff00;
      width: 8.56rem /* 642/75 */;
      position: absolute;
      bottom: 0.2rem;
      left: 50%;
      transform: translateX(-50%);
      p:nth-child(1) {
        text-align: center;
        font-size: 0.4267rem /* 32/75 */;
      }
      p:nth-child(2) {
        margin: 0 auto;
        margin-top: 0.15rem;
        width: 7.28rem /* 546/75 */;
      }
    }
  }
  .content-box {
    background-image: url('http://cdn.yxvzb.com/WEB/wx-master/images/zhuanti/BG.png');
    background-repeat: repeat;
    background-size: contain;
    .share-bt {
      border: 0.0267rem /* 2/75 */ solid #ebebeb;
      border-radius: 0.1067rem /* 8/75 */;
      width: 4rem /* 300/75 */;
      height: 0.7733rem /* 58/75 */;
      text-align: center;
      line-height: 0.7733rem /* 58/75 */;
      font-size: 0.3733rem /* 28/75 */;
      color: #ffffff;
      margin: auto;
      margin-top: 0.8rem /* 60/75 */;
    }
  }
  .share-box {
    width: 0.6947rem /* 52.1/75 */;
    position: fixed;
    right: 0;
    top: 65%;
  }
  .dialog-demo {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    top: 0;
    left: 0;
  }
  .dialog-div {
    height: 12rem /* 900/75 */;
    width: 95%;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    padding-top: 1rem;
    padding-bottom: 0.6rem;
    border-radius: 0.2133rem /* 16/75 */;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
    .icon-close1 {
      position: absolute;
      right: 0.2rem;
      top: 0.2rem;
      font-size: 0.5rem;
      color: #027cfa;
    }
  }
  .dialog-d2 {
    width: 100%;
    height: 11rem;
    position: absolute;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
    bottom: 0;
  }
  .comment-box {
    margin-top: 1.88rem;
  }
}
</style>
